import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import GameResults from '../components/game/GameResults';

const GameResultsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const results = location.state?.results;

  // No results in router state (e.g., direct visit or refresh) — send back to game.
  useEffect(() => {
    if (!results) navigate('/game', { replace: true });
  }, [results, navigate]);

  if (!results) return null;

  return (
    <GameResults
      results={results}
      onPlayAgain={() => navigate('/game', { state: { autoStart: true } })}
      onViewLeaderboard={() => navigate('/leaderboard')}
    />
  );
};

export default GameResultsPage;
